import { defineComponent as D, ref as d, watch as _, resolveComponent as p, createBlock as k, openBlock as v, withCtx as B, createVNode as h, renderSlot as N, createElementVNode as u, createElementBlock as b, createCommentVNode as M, Fragment as H, renderList as L, toDisplayString as j, withModifiers as A, normalizeClass as z } from "vue";
import { v as U } from "../../vsModal-BLdVBDEF.mjs";
import { v as I } from "../../vsIcon-Cyr63bPF.mjs";
import { v as q } from "../../vsCard-CgHEnE92.mjs";
import { v as F } from "../../vsAvatar-SOtko3H3.mjs";
import { v as K } from "../../vsSearchbar-BcFFAVue.mjs";
import { o as $ } from "../../index-BTmZbsz8.mjs";
import { _ as G } from "../../_plugin-vue_export-helper-CHgC5LLL.mjs";
const J = D({
  name: "vs-omni-search",
  components: {
    vsModal: U,
    vsIcon: I,
    vsCard: q,
    vsAvatar: F,
    vsSearchbar: K
  },
  props: {
    modelValue: { type: Boolean, default: !1 },
    recentSearches: { type: Object, default: null },
    results: { type: Object, default: null }
  },
  emits: ["close", "update:modelValue", "search:select", "search:changed"],
  setup(e, { emit: l }) {
    const V = d(), g = d();
    let y = null;
    _(g, () => {
      y && clearTimeout(y), y = setTimeout(() => {
        l("search:changed", g.value);
      }, 200);
    });
    const i = d(e.modelValue);
    _(i, () => {
      l("update:modelValue", i);
    }), _(() => e.modelValue, () => {
      i.value = e.modelValue;
    });
    const a = d(0), s = d(0), C = (t, n) => t === s.value && n === a.value, f = d(!1), w = () => {
      f.value = !0, setTimeout(() => {
        f.value = !1;
      }, 100), setTimeout(() => {
        const t = r.value[0].$el, n = t.parentElement.parentElement.parentElement;
        t.getBoundingClientRect().bottom + 2 * t.offsetHeight >= n.getBoundingClientRect().bottom && t.scrollIntoView({ block: "nearest", inline: "start" }), t.getBoundingClientRect().top < n.getBoundingClientRect().top && t.scrollIntoView({ block: "nearest", inline: "end" });
      }, 0);
    }, o = (t, n) => {
      f.value || (s.value = t, a.value = n);
    };
    $("ArrowDown", (t) => {
      !i.value || !e.results || e.results.length === 0 || (a.value < e.results[s.value].items.length - 1 ? a.value += 1 : s.value === e.results.length - 1 ? (s.value = 0, a.value = 0) : (s.value += 1, a.value = 0), w(), t.preventDefault());
    }), $("ArrowUp", (t) => {
      var n;
      !i.value || !e.results || ((n = e.results) == null ? void 0 : n.length) === 0 || (a.value > 0 ? a.value -= 1 : s.value === 0 ? (s.value = e.results.length - 1, a.value = e.results[s.value].items.length - 1) : (s.value -= 1, a.value = e.results[s.value].items.length - 1), w(), t.preventDefault());
    }), $("Enter", (t) => {
      i.value && (i.value = !1, l("search:select", e.results[s.value].items[a.value]));
    });
    const r = d();
    return { showModal: i, searchbar: V, searchText: g, currentItemIndex: a, currentSectionIndex: s, blockSelect: f, setCurrentItem: o, isCurrentItem: C, currentItem: r, parseHTML: (t, n, E) => {
      const O = C(n, E);
      try {
        const T = t.mark || "", R = new RegExp(T, "gi");
        return t.name.replace(R, `<span class="font-bold ${O ? "underline" : "text-primary"}">${T}</span>`);
      } catch {
        return t.name;
      }
    }, focusSearchbar: () => {
      V.value.$el.children[1].focus();
    } };
  }
}), P = { class: "h-80 overflow-scroll mb-10" }, Q = {
  key: 0,
  class: "w-full text-center my-20"
}, W = { key: 1 }, X = { class: "text-primary font-bold sticky top-0 pb-2 w-full bg-surface z-10 mt-2" }, Y = { class: "flex items-center" }, Z = { class: "flex flex-col" }, x = ["innerHTML"], ee = ["innerHTML"], te = { class: "absolute bottom-0 left-0 rounded-b flex text-sm py-4 bg-surface w-full pl-5 border-t" }, se = { class: "flex mr-5" }, re = { class: "flex" };
function le(e, l, V, g, y, i) {
  const a = p("vs-searchbar"), s = p("vs-icon"), C = p("vs-avatar"), f = p("vs-card"), w = p("vs-modal");
  return v(), k(w, {
    class: "relative",
    modelValue: e.showModal,
    "onUpdate:modelValue": l[1] || (l[1] = (o) => e.showModal = o),
    buttonless: "",
    noCloseButton: "",
    onOpened: e.focusSearchbar,
    onClosed: l[2] || (l[2] = (o) => {
      e.searchText = "", e.$emit("close");
    })
  }, {
    default: B(() => [
      h(a, {
        modelValue: e.searchText,
        "onUpdate:modelValue": l[0] || (l[0] = (o) => e.searchText = o),
        ref: "searchbar"
      }, null, 8, ["modelValue"]),
      N(e.$slots, "filters"),
      u("div", P, [
        !e.recentSearches && !e.results ? (v(), b("div", Q, " No hay búsquedas recientes ")) : e.results ? (v(), b("div", W, [
          (v(!0), b(H, null, L(e.results.filter((o) => {
            var r;
            return ((r = o.items) == null ? void 0 : r.length) > 0;
          }), (o, r) => (v(), b("div", {
            class: "pb-5",
            key: r
          }, [
            u("div", X, j(o.name), 1),
            (v(!0), b(H, null, L(o.items, (c, m) => (v(), k(f, {
              key: c.id,
              ref_for: !0,
              ref: e.isCurrentItem(r, m) ? "currentItem" : "",
              class: z(["flex justify-between shadow-none bg-surface items-center my-0.5 cursor-pointer", [
                e.isCurrentItem(r, m) ? "!bg-primary text-on-primary" : "",
                c.disabled ? "opacity-50 pointer-events-none" : ""
              ]]),
              onMouseover: (t) => e.setCurrentItem(r, m),
              onClick: A((t) => {
                e.setCurrentItem(r, m), e.showModal = !1, e.searchText = "", e.$emit("search:select", c);
              }, ["stop"])
            }, {
              default: B(() => [
                u("div", Y, [
                  c.icon ? (v(), k(s, {
                    key: 0,
                    name: c.icon,
                    size: 30,
                    color: e.isCurrentItem(r, m) ? "on-primary" : "",
                    class: "mr-2 opacity-80"
                  }, null, 8, ["name", "color"])) : M("", !0),
                  o.avatar ? (v(), k(C, {
                    key: 1,
                    name: c.name,
                    avatar: c.avatar,
                    class: "mr-2"
                  }, null, 8, ["name", "avatar"])) : M("", !0),
                  u("div", Z, [
                    u("div", {
                      innerHTML: e.parseHTML(c, r, m)
                    }, null, 8, x),
                    u("div", {
                      class: "text-sm opacity-75",
                      innerHTML: c.footer
                    }, null, 8, ee)
                  ])
                ]),
                h(s, {
                  size: 24,
                  class: z(["mr-2", e.isCurrentItem(r, m) ? "" : "opacity-50"]),
                  color: e.isCurrentItem(r, m) ? "white" : "",
                  name: "mi:enter"
                }, null, 8, ["class", "color"])
              ]),
              _: 2
            }, 1032, ["class", "onMouseover", "onClick"]))), 128))
          ]))), 128))
        ])) : M("", !0)
      ]),
      u("div", te, [
        u("div", se, [
          h(s, {
            size: 16,
            class: "opacity-50 mr-2",
            name: "mi:enter"
          }),
          l[3] || (l[3] = u("div", null, "para seleccionar", -1))
        ]),
        u("div", re, [
          h(s, {
            size: 16,
            class: "opacity-50",
            name: "akar-icons:arrow-up"
          }),
          h(s, {
            size: 16,
            class: "opacity-50 mr-2",
            name: "akar-icons:arrow-down"
          }),
          l[4] || (l[4] = u("div", null, " para navegar", -1))
        ])
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "onOpened"]);
}
const S = /* @__PURE__ */ G(J, [["render", le]]);
S.install = (e) => {
  e.component(S.name, S);
};
export {
  S as default
};
//# sourceMappingURL=index.mjs.map
